import React from "react";

const Heading = () => {
  return (
    <div className="App-header">
      <img
        className="logo"
        src="https://www.svgrepo.com/show/288092/hotel.svg"
        alt="Hotel Logo"
      />
      <header>CYF Hotel</header>
    </div>
  );
};

export default Heading;
